export enum ResultEnum {
    Equal = 1,
    Positive = 2,
    Negative = 3
}
